import React from "react";
import { PlaneLanding, TreePalm, Map } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { SERVICES } from "../mock";
import SectionHeader from "./SectionHeader";
import useReveal from "../hooks/useReveal";

const ICONS = { PlaneLanding, TreePalm, Map };

export default function Services() {
  const { t, S } = useLang();
  const ref = useReveal();

  return (
    <section id="servicios" ref={ref} className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <SectionHeader kicker={t(S.services.kicker)} title={t(S.services.title)} sub={t(S.services.sub)} />

        <div className="mt-14 grid md:grid-cols-3 gap-7">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <div
                key={s.id}
                className="group card-lift reveal bg-white rounded-2xl overflow-hidden border border-border shadow-sm"
                style={{ transitionDelay: `${i * 90}ms` }}
              >
                <div className="relative h-52 overflow-hidden">
                  <img src={s.img} alt={t(s.title)} className="w-full h-full object-cover img-zoom" />
                  <div className="absolute top-4 left-4 grid place-items-center w-12 h-12 rounded-xl bg-white/90 backdrop-blur text-primary shadow">
                    <Icon className="w-6 h-6" />
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="font-display font-bold text-xl text-foreground">{t(s.title)}</h3>
                  <p className="mt-3 text-muted-foreground leading-relaxed">{t(s.desc)}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
